export enum DialogType {
  Confirm,
  Message,
  Custom,
}
